
<ng-template #partTemplate let-label let-text>
    <div class="flex-row">
        <span class="light-bold mat-body-1 opacity-75">{{label | translate}} {{': '}}</span>
        <span class="mat-body-2 opacity-75">{{text}}</span>
    </div>
</ng-template>

<div class="full-width flex-column gap-small padding-standard">
    
    <h4 class="mat-headline-6 margin-none light-bold ">
        <span *ngIf="showIdxObs | async">{{((activitySubject | async).orderIndex +1)+'. '}}</span>
        {{actorDisplayObs | async}}
        <span class="mat-body-1 opacity-75">({{emailObs | async}})</span>
    </h4>

    <h6 class="mat-body-1 mat-mdc-card-subtitle margin-none ">
        <span class="light-bold">{{'ss-process-wizard.documents-to-sign' | translate }}{{': '}}</span>{{activityDocumentsDisplayObs | async}}
    </h6>



    <div class="flex-row">
        <span class="mat-body-1 light-bold opacity-75">{{'ss-entities.process.status' | translate}}{{': '}}</span>
        <span  [class]="statusDisplayClassObs | async">
            {{statusDisplayObs |async |translate}}
            
        </span>

        <span *ngIf="showStatusChangedDateObs | async" class="opacity-75">
            {{' '}}{{'ss-entities.process.rejected-on' | translate}}{{' '}}
            {{statusChangedDateObs | async}}
        </span>
    </div>
    <div class="flex-row opacity-75" *ngIf="showRejectionReasonObs | async">
        <span class="mat-body-1 light-bold ">{{'ss-entities.activity.reject.reason' | translate}}{{': '}}</span>
        <span>{{statusChangedReasonObs | async }}</span>
        
        
    </div>
    
    

</div>